import { render, staticRenderFns } from "./rturngoodModifyRemarks.vue?vue&type=template&id=7e460f48"
import script from "./rturngoodModifyRemarks.vue?vue&type=script&lang=js"
export * from "./rturngoodModifyRemarks.vue?vue&type=script&lang=js"
import style0 from "./rturngoodModifyRemarks.vue?vue&type=style&index=0&id=7e460f48&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports